import ProductPage from '../+Page';

export default function ProductProductsProductIdPage() {
  return <ProductPage />;
}
